export const PRIVACY_SETTING_LOADING = "PRIVACY_SETTING_LOADING";
export const GET_PRIVACY_SETTING = "GET_PRIVACY_SETTING";
export const UPDATE_PRIVACY_SETTING_SUCCESS = "UPDATE_PRIVACY_SETTING_SUCCESS";
export const UPDATE_PRIVACY_SETTING_FAIL = "UPDATE_PRIVACY_SETTING_FAIL";
export const GET_DEACTIVATE_REASON = "GET_DEACTIVATE_REASON";
export const DEACTIVATE_ACCOUNT_SUCCESS = "DEACTIVATE_ACCOUNT_SUCCESS";
export const DEACTIVATE_ACCOUNT_FAIL = "DEACTIVATE_ACCOUNT_FAIL";
export const REMOVE_PRIVACY_SETTING_DATA = "REMOVE_PRIVACY_SETTING_DATA";
